// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SjNK","productName":"Table_productName__LFjGs"};